import { render, staticRenderFns } from "./ProductCyclopediaPropertiesCard.vue?vue&type=template&id=58d1fb83&scoped=true&"
import script from "./ProductCyclopediaPropertiesCard.vue?vue&type=script&lang=js&"
export * from "./ProductCyclopediaPropertiesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d1fb83",
  null
  
)

export default component.exports